import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "input", "chat", "file", "label", "textarea", "textLimit", "messages" ]

  connect() {
    this.scrollToBottom()
    this.setupMessageObserver()
  }

  disconnect() {
    if (this.messageObserver) {
      this.messageObserver.disconnect()
    }
  }

  isScrolledToBottom() {
    if (!this.hasMessagesTarget) return false

    const threshold = 100 // pixels from bottom
    const scrollTop = this.messagesTarget.scrollTop
    const scrollHeight = this.messagesTarget.scrollHeight
    const clientHeight = this.messagesTarget.clientHeight

    return scrollHeight - scrollTop - clientHeight < threshold
  }

  scrollToBottom() {
    if (this.hasMessagesTarget) {
      this.messagesTarget.scrollTop = this.messagesTarget.scrollHeight
    }
  }

  setupMessageObserver() {
    if (!this.hasMessagesTarget) return

    // Watch for changes in the messages container
    this.messageObserver = new MutationObserver((mutations) => {
      // Auto-scroll if at bottom
      if (this.isScrolledToBottom()) {
        setTimeout(() => this.scrollToBottom(), 50)
      }
    })

    this.messageObserver.observe(this.messagesTarget, {
      childList: true,
      subtree: true
    })
  }

  filterList(e) {
    const value = this.inputTarget.value.toLowerCase();

    this.chatTargets.forEach((el) => {
      const isVisible = el.textContent.toLowerCase().indexOf(value) > -1
      el.style.display = isVisible ? "" : "none"
    })
  }

  handleKeydown(e) {
    // Submit form on Cmd+Enter (Mac) or Ctrl+Enter (Windows/Linux)
    if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) {
      e.preventDefault()
      const form = this.textareaTarget.closest('form')
      if (form) {
        form.requestSubmit()
      }
    }
  }

  onSubmit(e) {
    this.textareaTarget.focus()
    setTimeout( () => {
      this.textareaTarget.value = ''
      this.scrollToBottom()
    }, 100);
  }

  setFilename(e) {
    const el = this.fileTarget
    const label = this.labelTarget
    label.classList.toggle("Chat__Form__File__Label--with-file", !!el.value)
    
    if (this.hasTextLimitTarget) {
      this.textLimitTarget.style.display = el.value ? "none" : ""
    }
    
    if (el.value) {
      this.textareaTarget.value = "(Angehängte Datei)"
      this.textareaTarget.disabled = true
    }
  }

  removeFile(e) {
    this.fileTarget.value = ""
    this.labelTarget.classList.remove("Chat__Form__File__Label--with-file")
    this.textareaTarget.value = ""
    this.textareaTarget.disabled = false
    
    if (this.hasTextLimitTarget) {
      this.textLimitTarget.style.display = ""
    }
    
    e.stopImmediatePropagation()
    e.preventDefault()
  }
}
